import React, { useState } from 'react';
import IssuesList from '../IssuesList';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import RepositoryIssuesListOverview from './RepositoryIssuesListOverview';

const RepositoryIssueList = (props) => {
    const [active, setActive] = useState('1');
    return (
        <React.Fragment>
            <Nav tabs>
                <NavItem>
                    <NavLink
                        active={active === '1'}
                        href="#"
                        onClick={() => {
                            setActive('1');
                        }}>
                        Overview
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        active={active === '2'}
                        href="#"
                        onClick={() => {
                            setActive('2');
                        }}>
                        Secrets
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        active={active === '3'}
                        href="#"
                        onClick={() => {
                            setActive('3');
                        }}>
                        Repository
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        active={active === '4'}
                        href="#"
                        onClick={() => {
                            setActive('4');
                        }}>
                        IaC
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        active={active === '5'}
                        href="#"
                        onClick={() => {
                            setActive('5');
                        }}>
                        Dependency Issues
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        active={active === '6'}
                        href="#"
                        onClick={() => {
                            setActive('6');
                        }}>
                        Dependency Licenses
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={active}>
                <TabPane tabId="1">
                    <RepositoryIssuesListOverview />
                </TabPane>
                <TabPane tabId="2">
                    <IssuesList listUrl="scan/repository/secret/report/list" type="secrets" />
                </TabPane>
                <TabPane tabId="3">
                    <IssuesList listUrl="scan/repository/report/list" type="repository" />
                </TabPane>
                <TabPane tabId="4">
                    <IssuesList listUrl="scan/iac/report/list" type="iac" />
                </TabPane>
                <TabPane tabId="5">
                    <IssuesList listUrl="scan/dependency/report/list" type="dependency issues" />
                </TabPane>
                <TabPane tabId="6">
                    <IssuesList listUrl="scan/dependency/licenses/list" type="dependency license" />
                </TabPane>
            </TabContent>
        </React.Fragment>
    );
};

export default RepositoryIssueList;
